import { NotificationType } from "./type-models";

export class ToastMessage {

    public message: string;
    public msgType: NotificationType;

    /** How long the toast stays, in milliseconds, when it is to stay longer than the default */
    public durationMs?: number;

    public constructor(msg:string, type: NotificationType, durationMs?: number){
        this.message = msg;
        this.msgType = type;
        this.durationMs = durationMs;
    }
}